import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

type PageContentProps = {
  children: ReactNode;
  className?: string;
};

export function PageContent({ children, className }: PageContentProps) {
  return <div className={cn('w-full max-w-6xl', className)}>{children}</div>;
}
